module.exports = __webpack_public_path__ + "static/media/proj2_img3.4b122b27.jpg";